/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Book_Project_Panel_TitleInputs */

const en_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physical Book Production`)
};

const es_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producción de Libro Físico`)
};

const fr_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Production de Livre Physique`)
};

const de_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physische Buchproduktion`)
};

const ja_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物理的な本の制作`)
};

const zh_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实体书生产`)
};

const ar_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنتاج الكتاب المادي`)
};

const id_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produksi Buku Fisik`)
};

const it_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produzione Libro Fisico`)
};

const ru_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Производство Физической Книги`)
};

const pt_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produção de Livro Físico`)
};

const ko_book_project_panel_title = /** @type {(inputs: Book_Project_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실물 책 제작`)
};

/**
* | output |
* | --- |
* | "Physical Book Production" |
*
* @param {Book_Project_Panel_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const book_project_panel_title = /** @type {((inputs?: Book_Project_Panel_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Book_Project_Panel_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_book_project_panel_title(inputs)
	if (locale === "es") return es_book_project_panel_title(inputs)
	if (locale === "fr") return fr_book_project_panel_title(inputs)
	if (locale === "de") return de_book_project_panel_title(inputs)
	if (locale === "ja") return ja_book_project_panel_title(inputs)
	if (locale === "zh") return zh_book_project_panel_title(inputs)
	if (locale === "ar") return ar_book_project_panel_title(inputs)
	if (locale === "id") return id_book_project_panel_title(inputs)
	if (locale === "it") return it_book_project_panel_title(inputs)
	if (locale === "ru") return ru_book_project_panel_title(inputs)
	if (locale === "pt") return pt_book_project_panel_title(inputs)
	return ko_book_project_panel_title(inputs)
});